import { DIRECTORY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { getEntityType } from '../../utils';
import EntityNameDisplay from './EntityNameDisplay';
import investigateIcon from '../../common/Images/investigation_blue.png';
import azureIcon from '../../Investigation/Images/azure-grey.svg';
import oktaIcon from '../../Investigation/Images/okta-grey.svg';

import styles from '../EntitiesPopup.module.css';
import { useState } from 'react';
import { useAppDrawer } from '../../AppDrawer/AppDrawerProvider';
import InvestigationDrawer from '../../InvestigationDrawer/InvestigationDrawer';

const EntityRow = ({
    index,
    entityData,
    allowRemoveEntities,
    isApplicationObject,
    jumpToInvestigation,
    investigateClasses,
    entityType,
    jumpToPolicy,
    ExtraDataComponent,
    checked,
    onSelectEntity,
    explainabilityTitle
}) => {
    const [showExtraData, setShowExtraData] = useState(false);
    const { displayContent } = useAppDrawer();

    return (
        <div className="entityRow">
            <div className="entityData" onClick={() => setShowExtraData((prev) => !prev)}>
                {allowRemoveEntities && (
                    <input
                        readOnly
                        checked={checked}
                        type="checkbox"
                        id={`entityCheckBox_${index}`}
                        onChange={(e) => {
                            onSelectEntity(e.target.checked, entityData);
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                )}
                <div className={`rowIndex ${!allowRemoveEntities ? 'noSelection' : ''}`}>{`${index}.`}</div>
                {isApplicationObject && (
                    <div className="imageContainer">
                        {entityData.type === DIRECTORY_TYPES.aad.key && <img src={azureIcon} alt="" />}
                        {entityData.type === DIRECTORY_TYPES.okta.key && <img src={oktaIcon} alt="" />}
                    </div>
                )}
                <EntityNameDisplay entityData={entityData} />
                {jumpToInvestigation && (
                    <div
                        className={investigateClasses}
                        title={'Investigate'}
                        onClick={() =>
                            displayContent(
                                <InvestigationDrawer
                                    guid={entityData.guid}
                                    adType={getEntityType(entityType, entityData)}
                                />
                            )
                        }>
                        <img src={investigateIcon} alt="" />
                    </div>
                )}
                {jumpToPolicy && (
                    <a
                        id={styles.buttonsSection}
                        title="Show Policy"
                        href={`/Policy#${entityData.id}`}
                        rel="noopener noreferrer"
                        target="_blank"
                        onClick={(e) => e.stopPropagation()}>
                        <div className={styles.createPolicyBtn}>Show Policy</div>
                    </a>
                )}
                {ExtraDataComponent && showExtraData && <i className={`fa fa-angle-up text-gray-400 text-3xl p-2`}></i>}
                {ExtraDataComponent && !showExtraData && (
                    <i className={`fa fa-angle-down text-gray-400 text-3xl p-2`}></i>
                )}
            </div>
            {ExtraDataComponent && showExtraData && (
                <div className="entityExtraDataContainer">
                    <ExtraDataComponent entityData={entityData} explainabilityTitle={explainabilityTitle} />
                </div>
            )}
        </div>
    );
};

export default EntityRow;
